import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store/store";
import axios from "axios";
import vuetify from "@/plugins/vuetify";
import moment from "moment";
import VueTheMask from "vue-the-mask";
import "@/plugins/vuetify-money.js";
import VueCurrencyInput from "vue-currency-input";

Vue.config.productionTip = false;

Vue.prototype.$appNombre = "Cuanto$ale";
Vue.prototype.$appVersion = "Versión 26.10.07";
Vue.prototype.$appAutor = "EkoGroup";
Vue.prototype.$menuPos1 = "HomePos1";
Vue.prototype.$menuAdministracion = "HomeAdministracion";
Vue.prototype.$menuBanco = "HomeBanco";
Vue.prototype.$menuCartera = "HomeCartera";
Vue.prototype.$menuCompra = "HomeCompra";
Vue.prototype.$menuVenta = "HomeVenta";
Vue.prototype.$id_TipoVentaArticulo_PorImporte = "I";
Vue.prototype.$id_TipoVentaArticulo_PorCantidad = "C";
Vue.prototype.$id_TipoIvaArticulo_Gravado = "G";
Vue.prototype.$id_TipoIvaArticulo_Diferencial = "D";
Vue.prototype.$id_TipoIvaArticulo_Exento = "E";
Vue.prototype.$nombreModulo_Banco = "BANCO";
Vue.prototype.$nombreModulo_Caja = "CAJA";
Vue.prototype.$nombreModulo_Cartera = "CARTERA";
Vue.prototype.$nombreModulo_Compra = "COMPRA";
Vue.prototype.$nombreModulo_Stock = "STOCK";
Vue.prototype.$nombreModulo_Sistema = "SISTEMA";
Vue.prototype.$nombreModulo_Venta = "VENTA";
Vue.prototype.$nombreModulo_EeSs = "EESS";
Vue.prototype.$nombreModulo_Gremio = "GREMIO";
Vue.prototype.$nombreTipoComprobante_Recibo = "RECIBO";
Vue.prototype.$nombreTipoComprobante_OrdenPago = "ORDEN DE PAGO";
Vue.prototype.$nombreCondicionVenta_Contado = "CONTADO";
Vue.prototype.$nombreTipoPago_Efectivo = "EFECTIVO";
Vue.prototype.$nombreTipoPago_Tarjeta = "TARJETA";
Vue.prototype.$nombreTipoPago_Cheque = "CHEQUE";
Vue.prototype.$nombreTipoPago_Transferencia = "TRANSFERENCIA";
Vue.prototype.$nombreTipoPago_ChequePropio = "CHEQUE PROPIO";
Vue.prototype.$nombreTipoPago_ChequeCartera = "CHEQUE CARTERA";
Vue.prototype.$fichaColumna_Debe = "D";
Vue.prototype.$id_TipoVenta_Distribuidor = "D";
Vue.prototype.$codigoTipoImporteCaja_VDA = "VDA";
Vue.prototype.$codigoTipoImporteCaja_D = "D";
Vue.prototype.$codigoTipoImporteCaja_R = "R";
Vue.prototype.$codigoTipoImporteCaja_VCC = "VCC";
Vue.prototype.$codigoTipoImporteCaja_TAR = "TAR";
Vue.prototype.$codigoTipoImporteCaja_CHE = "CHE";
Vue.prototype.$codigoTipoImporteCaja_CCC = "CCC";
Vue.prototype.$codigoTipoImporteCaja_IC = "IC";
Vue.prototype.$codigoTipoImporteCaja_EC = "EC";

export const eventBus = new Vue();

Vue.use(VueTheMask);

Vue.use(VueCurrencyInput, {
  globalOptions: {
    locale: "es-AR",
    currency: "ARS"
  }
});

Vue.use(require("vue-shortkey"));

Vue.filter("esFecha", function(valor) {
  let valorFormateado;
  if (valor) {
    let fecha = moment(new Date(valor));
    if (fecha.isValid()) valorFormateado = fecha.format("DD/MM/YYYY");
  } else valorFormateado = valor;
  return valorFormateado;
});

Vue.filter("esFechaHora", function(valor) {
  let valorFormateado;
  if (valor) {
    let fecha = moment(new Date(valor));
    if (fecha.isValid()) valorFormateado = fecha.format("DD/MM hh:mm");
  } else valorFormateado = valor;
  return valorFormateado;
});

Vue.filter("esFechaMesAño", function(valor) {
  let valorFormateado;
  if (valor) {
    let fecha = moment(new Date(valor));
    if (fecha.isValid()) valorFormateado = fecha.locale("es").format("MMM/YY");
  } else valorFormateado = valor;
  return valorFormateado;
});

Vue.filter("esMoneda", function(valor) {
  let valorFormateado;
  if (valor) {
    let formatter = new Intl.NumberFormat("es-AR", {
      style: "currency",
      currency: "ARS"
    });
    valorFormateado = formatter.format(valor);
  } else valorFormateado = "$ 0,00";
  return valorFormateado;
});

const token = localStorage.getItem("user-token");
if (token) {
  axios.defaults.headers.common["Authorization"] = token;

  // Add a request interceptor
  axios.interceptors.request.use(
    function(config) {
      // Do something before request is sent
      return config;
    },
    function(error) {
      // Do something with request error
      console.error("Request Error  " + error.response.status);
      return Promise.reject(error);
    }
  );

  // Add a response interceptor
  axios.interceptors.response.use(
    function(response) {
      // Do something with response data
      return response;
    },
    function(error) {
      // Do something with response error
      console.error("Response Error " + error.response.status);
      return Promise.reject(error);
    }
  );
}

new Vue({
  router,
  store, // register the Vuex store globally
  vuetify,
  render: h => h(App)
}).$mount("#app");
